import { faArrowLeftLong } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'react-switch-lang';
import Link from './Link';
import { events } from '../utils/Amplitude';

function BackButton({ textKey, path, arrowIcon = true, narrow = false }) {
  return (
    <Link
      href={path}
      ampEvent={events.USER_CLICKED_BACK_BUTTON}
      ampEventProps={{ Button: t(textKey, null, 'en') }}
      className={narrow ? 'backButtonNarrow' : 'backButton'}
    >
      {arrowIcon && <FontAwesomeIcon icon={faArrowLeftLong} />}
      <span>{t(textKey)}</span>
    </Link>
  );
}

export default BackButton;
